import { createContext } from 'react';
import { EditVersionContextType } from '@/context/EditVersionContext/types.ts';

const EditVersionContext = createContext<EditVersionContextType | undefined>(undefined);
export default EditVersionContext;
